/**
 * Store
 * @author David <david.prenninger@gmx.de>
 *
 * This acts as entry point to the application store.
 * It loads all modules from '@/store/modules'
 */
import Vue from 'vue';
import Vuex from 'vuex';

import modules from '@/store/modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
});
